import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { SectionChiefInfo } from 'components/IAP/planningView/widgets/AssignmentList/useSectionChiefResolver';
import { useActualIncidentId } from 'components/IAP/hooks/commonHooks';
import config from 'constants/apiConfig';

export const keys = {
  sectionChief: 'sectionChief',
};

export const useResolveSectionChief = (targetWorkGroupId: string) => {
  const currentIncidentId = useActualIncidentId();

  const baseUrl = `${config.apiGateway.ics_work_assignment_list_attachment}/${currentIncidentId}`;

  return useQuery({
    queryKey: [keys.sectionChief, currentIncidentId],
    queryFn: async () => {
      const response = await axios.get(
        `${baseUrl}/sectionChiefInfo/${targetWorkGroupId}`
      );
      return response.data as SectionChiefInfo;
    },
    enabled: !!currentIncidentId,
  });
};
